export function openDatabase() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('recipes-db', 1);
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('offline-recipes')) {
          db.createObjectStore('offline-recipes', { keyPath: 'id', autoIncrement: true });
        }
      };
  
      request.onsuccess = (event) => resolve(event.target.result);
      request.onerror = (event) => reject(event.target.error);
    });
  }